import type * as React from "react";

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: React.ReactNode;
  description?: React.ReactNode;
  footer?: React.ReactNode;
  actions?: React.ReactNode;
  hover?: boolean;
  /** Remove body padding (tables). */
  flush?: boolean;
};

/** Surface container with optional header/footer and the signature lift + pink glow on hover. */
export function Card({
  title,
  description,
  footer,
  actions,
  hover = false,
  flush = false,
  className = "",
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={["pr-card", hover ? "pr-card--hover" : "", className].filter(Boolean).join(" ")}
      {...props}
    >
      {(title || description || actions) && (
        <div
          className="pr-card__header"
          style={{ display: "flex", alignItems: "flex-start", gap: 12 }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            {title && <h3 className="pr-card__title">{title}</h3>}
            {description && <p className="pr-card__desc">{description}</p>}
          </div>
          {actions}
        </div>
      )}
      {children != null && <div className={flush ? undefined : "pr-card__body"}>{children}</div>}
      {footer && <div className="pr-card__footer">{footer}</div>}
    </div>
  );
}
